// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file DialogContext.ts
 * @input React context
 * @output Internal dialog context for child focus behavior
 * @position Dialog internals; consumed by focus-managing children
 */
import { createContext, use } from 'react';
export const DialogContext = /*#__PURE__*/createContext(null);
DialogContext.displayName = 'DialogContext';
export function useDialogContext() {
  return use(DialogContext);
}